import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { useLang } from "@/contexts/LangContext";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const { t, lang } = useLang();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(form.email, form.password, form.name);
      toast.success(lang === "tr" ? "Kayıt başarılı" : "Registered");
      navigate("/account");
    } catch (err) {
      const d = err?.response?.data?.detail;
      toast.error(typeof d === "string" ? d : (lang === "tr" ? "Kayıt başarısız" : "Registration failed"));
    } finally { setLoading(false); }
  };

  return (
    <div data-testid="register-page" className="px-6 py-20 max-w-md mx-auto">
      <h1 className="font-heading text-4xl mb-2 text-center">{t("auth.register_title")}</h1>
      <p className="text-xs uppercase tracking-[0.2em] text-center text-[#C8A96A] mb-10">Uzungöl Kuyumculuk</p>
      <form onSubmit={submit} className="space-y-6">
        <Field label={t("auth.name")} testid="reg-name" value={form.name} onChange={(v) => setForm({ ...form, name: v })} />
        <Field label={t("auth.email")} testid="reg-email" type="email" value={form.email} onChange={(v) => setForm({ ...form, email: v })} />
        <Field label={t("auth.password")} testid="reg-password" type="password" value={form.password} onChange={(v) => setForm({ ...form, password: v })} />
        <button data-testid="reg-submit" disabled={loading} className="w-full bg-[#0A0A0A] hover:bg-[#C8A96A] text-white py-4 text-xs uppercase tracking-[0.25em] transition-colors disabled:opacity-50">
          {loading ? t("common.loading") : t("auth.submit_register")}
        </button>
      </form>
      <p className="text-center text-sm text-[#52525B] mt-8">
        {t("auth.have_account")} <Link to="/login" className="text-[#C8A96A] underline underline-offset-4">{t("auth.submit_login")}</Link>
      </p>
    </div>
  );
}

function Field({ label, testid, value, onChange, type = "text" }) {
  return (
    <div>
      <label className="block text-[10px] uppercase tracking-[0.2em] mb-2">{label}</label>
      <input data-testid={testid} type={type} value={value} onChange={(e) => onChange(e.target.value)} required
        className="w-full border-b border-[#0A0A0A] bg-transparent py-2 text-sm focus:outline-none focus:border-[#C8A96A]" />
    </div>
  );
}
